import { useState, useEffect } from "react";

const MensagemQualificadaSection = () => {
  const imagens = [
    "/mockups/screenshot-1.png",
    "/mockups/screenshot-2.png",
    "/mockups/screenshot-3.png",
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % imagens.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-24 px-6 sm:px-12 text-gray-900">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Texto */}
        <div className="text-center lg:text-left">
          <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-800/80">
            Vendas começam pelo DESEJO
          </h3>
          <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight leading-tight text-gray-900">
            Uma Vintree pode fazer muito pelo seu funil de vendas
          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-800/90 max-w-xl mx-auto lg:mx-0">
            Sua vitrine virtual gera desejo e qualifica a conversa. Quando a
            mensagem chega no Whats, o cliente já sabe o que quer.
          </p>
        </div>

        {/* Imagem com transição suave */}
        <div className="relative w-full max-w-sm mx-auto aspect-[9/16]">
          {imagens.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Preview ${i}`}
              className={` absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out rounded-2xl ${
                i === index ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MensagemQualificadaSection;
